/**
 * Maps ISO 3166-1 alpha-2 country codes (from react-phone-number-input)
 * to alpha-3 codes used by the backend PhoneCountryCodeEnum.
 */
export type PhoneCountryCodeEnum = 'BRA' | 'CAN' | 'AUS' | 'NZL' | 'USA' | 'GBR';

const ALPHA2_TO_ALPHA3: Record<string, PhoneCountryCodeEnum> = {
  BR: 'BRA',
  CA: 'CAN',
  AU: 'AUS',
  NZ: 'NZL',
  US: 'USA',
  GB: 'GBR',
};

/**
 * Converts alpha-2 country code to PhoneCountryCodeEnum (alpha-3).
 * Returns undefined if the country is not supported.
 */
export function alpha2ToPhoneCountryCode(alpha2: string): PhoneCountryCodeEnum | undefined {
  return ALPHA2_TO_ALPHA3[alpha2.toUpperCase()];
}
